export const FacebookSVG = ({ width = 36, height = 36 }) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: do not need title
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5758 18.064C35.5758 8.38102 27.7068 0.53125 18.0001 0.53125C8.29333 0.53125 0.424316 8.38102 0.424316 18.064C0.424316 26.2862 6.09918 33.1857 13.7545 35.0806V23.422H10.1304V18.064H13.7545V15.7553C13.7545 9.78785 16.4618 7.02188 22.335 7.02188C23.4486 7.02188 25.3699 7.23998 26.1559 7.45739V12.314C25.7411 12.2705 25.0205 12.2487 24.1256 12.2487C21.2439 12.2487 20.1303 13.3379 20.1303 16.1691V18.064H25.8712L24.8848 23.422H20.1303V35.4684C28.8317 34.42 35.5758 27.0282 35.5758 18.064Z"
        fill="#0966FF"
      />
    </svg>
  );
};
